import Mail from '../../../images/mail.svg'
import Phone from '../../../images/phone.svg'
import Map from '../../../images/map.svg'
import Footer1 from '../../../images/footer_1.png'
import Footer2 from '../../../images/footer_2.png'
import Footer3 from '../../../images/footer_3.png'
import Footer4 from '../../../images/footer_4.png'
import Footer5 from '../../../images/footer_5.png'
import Footer6 from '../../../images/footer_6.png'
import Footer7 from '../../../images/footer_7.png'
import Footer8 from '../../../images/footer_8.png'

export const INFORMATION_LIST = [
    {
        title: 'Lễ Vu Quy',
        time: 'Thứ 7, 3 tháng 12, 2022 11AM - 2AM',
        address: 'Nhà hàng tiệc cưới Quang Hương, Thôn 10, Xã Hòa Phú, BMT',
        phone: '083 247 5475',
    },
    {
        title: 'Lễ Tân Hôn',
        time: 'CN, 4 tháng 12, 2022 11AM - 2AM',
        address: 'Nhà hàng tiệc cưới Thu Hương, Võ Văn Kiệt, P Khánh Xuân, BMT',
        phone: '083 247 5475',
    },
    {
        title: 'Lễ Báo Hỉ',
        time: 'Thứ 7, 17 tháng 12, 2022 18PM - 21PM',
        address: 'Nhà hàng tiệc cưới EMERALD, 139 Hoàng Diệu 2, Linh Trung, Thủ Đức, HCM',
        phone: '0969795353',
        map: 'https://goo.gl/maps/Gj586uxX9kDq7stu5'
    }
]

export const CONTACT_LIST = [
    {
        icon: Mail,
        text: 'trungdd@luminpdf.com',
    },
    {
        icon: Phone,
        text: '+84896971916',
    },
    {
        icon: Map,
        text: '34 Ward, Bình An, District 2, Ho Chi Minh City',
    },
]

export const PICTURE_LIST = [
    {
        image: Footer1,
        alt: 'footer1',
    },
    {
        image: Footer2,
        alt: 'footer2',
    },
    {
        image: Footer3,
        alt: 'footer3',
    },
    {
        image: Footer4,
        alt: 'footer4',
    },
    {
        image: Footer5,
        alt: 'footer5',
    },
    {
        image: Footer6,
        alt: 'footer6',
    },
    {
        image: Footer7,
        alt: 'footer7',
    },
    {
        image: Footer8,
        alt: 'footer8',
    },
]
